import CancelAndRefund from "../../components/infoPages/cancelAndRefund";

const RefPage = ({authUser}) => {
  return (
    <div>
     <CancelAndRefund authUser={authUser} />
    </div>
  )
}

export default RefPage;